<template>
  <div style="background-color: #eee">
    <!--Advertisment card dialogs-->
    <DummyAdvertismentCard ref="dummyAdvDialog"></DummyAdvertismentCard>
    <AdvertismentCardTwo ref="AdvCardTwo"></AdvertismentCardTwo>

    <!--
      Button - A floating create new button 
      Path: components/general/button/
    -->
    <div v-if="isLoggedIn == true">
      <FrontpageCreateArticleButton></FrontpageCreateArticleButton>
    </div>

    <!--
      Display tags
      Path: components/general/tabs/
    -->
    <div class="pt-6">
      <v-tabs
        center-active
        grow
        v-if="TagProfiles && TagProfiles.length > 0"
        dark
        v-model="activeProfile"
        color="orange lighten-3"
      >
        <v-tab
          v-for="(profile, n) in TagProfiles"
          :key="profile.id"
          :class="'profile_' + n"
        >
          <span class="title">{{ profile.Name }}</span>
        </v-tab>
        <v-tab class="d-none"></v-tab>
      </v-tabs>
    </div>

    <!--Search n Filter-->

    <div style="background-color: #eee">
      <!--Normal-->
      <v-row v-if="$vuetify.breakpoint.smAndUp">
        <v-spacer></v-spacer>
        <!--Search bar-->
        <v-col md="4" class="ma-0 pa-0 pt-5">
          <v-text-field
            hide-details
            solo
            clearable
            prepend-icon="search"
            v-model="SearchArticles"
            @keyup.enter="createTempProfile"
            @click:clear="SearchArticles = ''"
            @click:prepend="createTempProfile"
            :placeholder="$t('Search')"
          ></v-text-field>
        </v-col>
        <v-col md="auto" class="ml-0 pl-0">
          <!--Menu for geo tagging n such-->
          <div class="text-center">
            <v-menu
              z-index="2"
              v-model="menu"
              attach
              :close-on-content-click="false"
              :close-on-click="false"
              :nudge-width="710"
              offset-x
              left
              nudge-left="-1"
              nudge-bottom="53"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon color="primary" v-on="on" large class="pa-1 mt-1">
                  <v-icon large>fas fa-sort-down</v-icon>
                </v-btn>
              </template>
              <!--Content-->
              <v-card>
                <v-card-text>
                  <!--Geo tags-->
                  <v-col>
                    <v-autocomplete
                      :label="$t('GeoTagging')"
                      v-model="newGeoTags"
                      :items="Geo.SearchTags"
                      :loading="Geo.IsLoading"
                      :search-input.sync="Geo.Search"
                      item-text="Label"
                      item-value="id"
                      autocomplete
                      multiple
                      chips
                      return-object
                      @change="selectedGeoEvent"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :input-value="data.selected"
                          close
                          class="chip--select-multi"
                          @click:close="removeGeoTag(data.item)"
                          @input="removeGeoTag(data.item)"
                          >#{{ data.item.Label }}</v-chip
                        >
                      </template>
                      <template v-slot:item="data">
                        <v-row align-start justify-space-around row fill-height>
                          <v-col>
                            <div class="headline">#{{ data.item.Label }}</div>
                          </v-col>
                        </v-row>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <!--Interest Tags-->
                  <v-col>
                    <v-autocomplete
                      :label="$t('Tagging')"
                      v-model="newTags"
                      :items="TagsOrdered"
                      :loading="Tag.IsLoading"
                      :search-input.sync="Tag.Search"
                      item-text="Label"
                      item-value="id"
                      autocomplete
                      multiple
                      chips
                      return-object
                      @change="selectedTagEvent"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          class="chip--select-multi"
                          @click:close="removeTag(data.item)"
                          @input="removeTag(data.item)"
                          >#{{ data.item.Label }}</v-chip
                        >
                      </template>
                      <template v-slot:item="data">
                        <v-row align-start justify-space-around row fill-height>
                          <v-col>
                            <div class="headline">#{{ data.item.Label }}</div>
                          </v-col>
                        </v-row>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <!--Search Button-->
                  <v-col class="text-end">
                    <v-btn
                      @click="createTempProfile"
                      v-text="$t('Search for articles')"
                    ></v-btn>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-menu>
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <!--Search n filter desktop end-->

      <!--Phone search and filter-->
      <v-row v-else class="ma-0 pa-0">
        <v-col class="ma-0 pa-0 pt-5 pl-3">
          <v-text-field
            hide-details
            solo
            clearable
            v-model="SearchArticles"
            @keyup.enter="createTempProfile"
            @click:clear="createTempProfile"
            @click:prepend="createTempProfile"
            :placeholder="$t('Search')"
          ></v-text-field>
        </v-col>
        <v-col cols="auto">
          <v-menu
            v-model="menu"
            z-index="2"
            :close-on-content-click="false"
            :close-on-click="false"
            :nudge-width="710"
            offset-x
            left
            nudge-left="5"
            nudge-bottom="55"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon color="primary" v-on="on" large class="pa-1 mt-1">
                <v-icon large>fas fa-sort-down</v-icon>
              </v-btn>
            </template>
            <!--Filter dropdown-->
            <v-card>
              <v-card-text>
                <!--Geo tags-->
                <v-col>
                  <v-autocomplete
                    :label="$t('GeoTagging')"
                    v-model="newGeoTags"
                    :items="Geo.SearchTags"
                    :loading="Geo.IsLoading"
                    :search-input.sync="Geo.Search"
                    item-text="Label"
                    item-value="id"
                    autocomplete
                    multiple
                    chips
                    return-object
                    @change="selectedGeoEvent"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :input-value="data.selected"
                        close
                        class="chip--select-multi"
                        @click:close="removeGeoTag(data.item)"
                        @input="removeGeoTag(data.item)"
                        >#{{ data.item.Label }}</v-chip
                      >
                    </template>
                    <template v-slot:item="data">
                      <v-row align-start justify-space-around row fill-height>
                        <v-col>
                          <div class="headline">#{{ data.item.Label }}</div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!--Interest Tags-->
                <v-col>
                  <v-autocomplete
                    :label="$t('Tagging')"
                    v-model="newTags"
                    :items="TagsOrdered"
                    :loading="Tag.IsLoading"
                    :search-input.sync="Tag.Search"
                    item-text="Label"
                    item-value="id"
                    autocomplete
                    multiple
                    chips
                    return-object
                    @change="selectedTagEvent"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :selected="data.selected"
                        close
                        class="chip--select-multi"
                        @click:close="removeTag(data.item)"
                        @input="removeTag(data.item)"
                        >#{{ data.item.Label }}</v-chip
                      >
                    </template>
                    <template v-slot:item="data">
                      <v-row align-start justify-space-around row fill-height>
                        <v-col>
                          <div class="headline">#{{ data.item.Label }}</div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!--Search Button-->
                <v-col class="text-end">
                  <v-btn
                    @click="createTempProfile"
                    v-text="$t('Apply form')"
                  ></v-btn>
                </v-col>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>
    </div>

    <!--Render in article on click (dialog)-->
    <v-dialog
      v-model="viewarticle"
      max-width="1000"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <!--If Finding the article data - open and display article-->
      <article-component
        v-if="Article.id"
        :articledata="Article"
        @updatearticle="setArticle()"
      ></article-component>
      <!--ELSE Not finding the article data, display a loader (skeleton - loader) -->
      <v-sheet v-else color="grey " class="px-3 pt-3 pb-3">
        <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
      </v-sheet>
    </v-dialog>

    <!--Display progress - when getting articles-->
    <v-dialog v-model="waitForServerResponse" fullscreen>
      <v-container fluid fill-height style="background-color: rgba(0,0,0,0.5)">
        <v-row align-center justify-center>
          <v-col xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar center dark color="primary">
                <v-spacer />
                <v-toolbar-title v-text="waitForServerResponseMsg">
                  <v-progress-circular indeterminate class="ml-2" />
                </v-toolbar-title>
                <v-spacer />
              </v-toolbar>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>

    <!--
      Top 4 cards
      Card 1, 3 and 4  = index 0, 1 and 2
      Card 2 = Custom Advertisment card
    -->
    <div style="background-color: #eee" v-if="LatestArticles.length">
      <v-container>
        <template v-if="$vuetify.breakpoint.smAndUp">
          <v-row>
            <!--Article 1 - big one-->
            <v-col md="6" class="ma-0 pa-0">
              <v-hover>
                <v-card
                  color="white"
                  :style="{
                    background: `url(${
                      LatestArticles[0].MediaData.length > 0
                        ? LatestArticles[0].MediaData[0]['s3url'] + '-web.jpg'
                        : ''
                    })`,
                    backgroundSize: 'cover',
                  }"
                  :to="{
                    name: `frontpage`,
                    params: { articleid: LatestArticles[0].id },
                  }"
                  replace
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 0}`"
                  class="redborderbottom"
                  height="100%"
                >
                  <v-row
                    :style="{
                      top: '50%',
                      position: 'relative',
                      transform: 'translateY(-50%)',
                      color: 'white',
                      textShadow:
                        '2px 2px 10px #000, 2px 2px 20px #000, -2px -2px 20px #000, 2px -2px 20px #000, -2px 2px 20px #000',
                    }"
                  >
                    <v-col class="ma-0 pa-0 pt-3">
                      <p
                        class="font-weight-bold headline pl-2 text-center mb-0 pb-1"
                        style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;"
                      >
                        {{ LatestArticles[0].Title }}
                      </p>
                      <div class="text-uppercase pl-6 body-2  text-center">
                        <span class="font-weight-light">{{
                          LatestArticles[0].Created
                            | localizeDate
                            | moment("LLL")
                        }}</span>
                      </div>
                      <div
                        class="body-1 pl-6 pr-3 pt-3"
                        style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                        v-html="LatestArticles[0].Content"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-hover>
            </v-col>
            <!--Card 2,3 and 4-->
            <!--Sidecards Desktop-->
            <v-col md="6" v-if="$vuetify.breakpoint.smAndUp" class="pt-0 pb-0">
              <v-row>
                <v-col md="12" class="pt-0 pb-0">
                  <!--Advertisment and article -->
                  <v-row class="ma-0 pa-0">
                    <!--Advertisment card-->
                    <v-col class="ma-0 pa-0 pa-1">
                      <v-card height="100%">
                        <AdvertismentCards></AdvertismentCards>
                      </v-card>
                    </v-col>
                    <v-col class="ma-0 pa-0 pa-1">
                      <v-hover>
                        <v-card
                          outlined
                          :to="{
                            name: `frontpage`,
                            params: { articleid: LatestArticles[1].id },
                          }"
                          replace
                          slot-scope="{ hover }"
                          :class="`expandCard elevation-${hover ? 12 : 0}`"
                          style="border:solid 1px black;"
                          class=" "
                          height="100%"
                        >
                          <!--Title-->
                          <v-row class="ma-0 pa-0">
                            <v-col class="ma-0 pa-0">
                              <p
                                class="font-weight-bold title pa-0 pt-4 ma-0 text-center"
                                style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;"
                              >
                                {{ LatestArticles[1].Title }}
                              </p>
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                          <v-divider></v-divider>
                          <v-row class="ma-0 pa-0">
                            <v-col class="ma-0 pa-0 py-2 pr-2 pa-2">
                              <div
                                style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                                v-html="LatestArticles[1].Content"
                              />
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                </v-col>
                <!--Last article in the top row-->
                <v-col md="12" class="pt-3 pb-0">
                  <v-hover>
                    <v-card
                      :to="{
                        name: `frontpage`,
                        params: { articleid: LatestArticles[2].id },
                      }"
                      replace
                      slot-scope="{ hover }"
                      :class="`expandCard elevation-${hover ? 12 : 0}`"
                      class="redborderbottom"
                      outlined
                    >
                      <v-row>
                        <v-col
                          md="auto"
                          :grow="$vuetify.breakpoint.xs"
                          :shrink="$vuetify.breakpoint.smAndUp"
                          class="ma-0 pa-0 ml-6 mt-2"
                        >
                          <v-img
                            v-if="
                              LatestArticles[2].MediaData &&
                                LatestArticles[2].MediaData.length > 0
                            "
                            :src="
                              `${LatestArticles[2].MediaData[0]['s3url']}-web.jpg`
                            "
                            :width="$vuetify.breakpoint.xs ? '' : '200px'"
                            height="200px"
                            :aspect-ratio="1.77"
                            cover
                          />
                          <v-img
                            v-else
                            :src="`/lrVxWoHA.png`"
                            width="100px"
                            height="100px"
                            contain
                          />
                        </v-col>
                        <v-col class="ma-0 pa-0 ml-6 pr-3">
                          <p
                            class="font-weight-regular headline"
                            style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;"
                          >
                            {{ LatestArticles[2].Title }}
                          </p>
                          <div class="text-uppercase">
                            <span class="font-weight-light body-2">{{
                              LatestArticles[1].Created
                                | localizeDate
                                | moment("LLL")
                            }}</span>
                          </div>
                          <p
                            style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; min-height:3em;"
                            v-html="LatestArticles[2].Content"
                          ></p>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </div>

    <!--
      Main Articles
    -->
    <div style="background-color: #eee">
      <v-container grid-list-xs>
        <v-row>
          <template v-for="(article, index) in LatestArticles.slice(3)">
            <!--RSS Articles-->
            <v-col
              cols="12"
              v-if="index % 8 == 0 && index != 0"
              :key="article.id.index"
            >
              <div>
                <v-container>
                  <v-row class="ma-0 pa-0">
                    <!--
                      Run a for loop through the articleFeed, slicing out 4 each time.
                      2 parameter,  from index -> up to index.   example.   0,4 = 0,1,2,3     4,8 = 4,5,6,7
                    -->
                    <template
                      v-for="articlefeed in ArticlesFeed.slice(
                        getArrayFeedIndex(index),
                        getArrayFeedIndex(index + 8)
                      )"
                    >
                      <v-col
                        class="ma-0 pa-0 pl-1 pr-1"
                        md="3"
                        :key="articlefeed.id"
                      >
                        <v-hover>
                          <v-card
                            slot-scope="{ hover }"
                            :class="`elevation-${hover ? 12 : 0}`"
                            height="100%"
                            :to="{
                              name: `frontpage`,
                              params: { articleid: articlefeed.id },
                            }"
                          >
                            <v-row class="ma-0 pa-0">
                              <v-col class="ma-0 pa-0 pa-2">
                                <p
                                  class="font-weight-bold subtitle-2 pt-1 mb-0 pb-1"
                                  style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;"
                                >
                                  {{ articlefeed.Title }}
                                </p>
                              </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row class="ma-0 pa-0">
                              <v-col class="ma-0 pa-0 pa-2">
                                <div
                                  class="body-1 pl-6 pr-3"
                                  style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                                  v-html="articlefeed.Content"
                                />
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-hover>
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </div>
            </v-col>

            <!--Normal Articles-->
            <v-col
              class="ma-0 pa-0 pa-2"
              md="6"
              :key="article.id"
              v-if="(index + 1) % 5"
            >
              <v-hover>
                <v-card
                  :to="{ name: `frontpage`, params: { articleid: article.id } }"
                  replace
                  slot-scope="{ hover }"
                  :class="`expandCard elevation-${hover ? 12 : 0}`"
                  class="redborderbottom"
                  height="100%"
                >
                  <v-row class="ma-0 pa-0">
                    <!--Image-->
                    <v-col md="3" class="ma-0 pa-0 mt-3 pa-2">
                      <v-img
                        v-if="article.MediaData && article.MediaData.length > 0"
                        :src="`${article.MediaData[0]['s3url']}-web.jpg`"
                        height="100%"
                        cover
                      />
                      <v-img
                        v-else
                        :src="`/lrVxWoHA.png`"
                        width="100px"
                        height="100px"
                        contain
                      />
                    </v-col>
                    <!--Title-->
                    <v-col md="9">
                      <p
                        class="font-weight-regular headline pa-0 ma-0 pb-2"
                        style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;"
                      >
                        {{ article.Title }}
                      </p>
                      <!--Created-->
                      <v-row class="ma-0 pa-0">
                        <v-col class="ma-0 pa-0 subtitle-2">
                          <span class="font-weight-light">{{
                            article.Created | localizeDate | moment("LLL")
                          }}</span>
                        </v-col>
                      </v-row>
                      <!--Content-->
                      <div
                        style="display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; overflow: hidden;"
                        v-html="article.Content"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-hover>
            </v-col>

            <!--Advert And small version of the article-->
            <v-col class="ma-0 pa-0" md="6" :key="article.id" v-else>
              <!--Desktop-->
              <div v-if="$vuetify.breakpoint.smAndUp">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0 pa-1">
                    <v-card height="100%">
                      <AdvertismentCards></AdvertismentCards>
                    </v-card>
                  </v-col>
                  <v-col class="ma-0 pa-0 pa-1">
                    <v-hover>
                      <v-card
                        outlined
                        :to="{
                          name: `frontpage`,
                          params: { articleid: article.id },
                        }"
                        replace
                        slot-scope="{ hover }"
                        :class="`expandCard elevation-${hover ? 12 : 0}`"
                        style="border:solid 1px black;"
                        class=" "
                        height="100%"
                      >
                        <!--Title-->
                        <v-row class="ma-0 pa-0">
                          <v-col class="ma-0 pa-0">
                            <p
                              class="font-weight-bold title pa-0 pt-4 pb-2 ma-0 text-center"
                              style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;"
                            >
                              {{ article.Title }}
                            </p>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-divider></v-divider>
                        <!--Text-->
                        <v-row class="ma-0 pa-0">
                          <v-col class="ma-0 pa-0 py-2 pr-2 pa-2">
                            <div
                              style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                              v-html="article.Content"
                            />
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-hover>
                  </v-col>
                </v-row>
              </div>
              <!--Phone-->
              <div v-else>
                <!--Phone Advertisment-->
                <v-row class="ma-0 pa-0 pa-2">
                  <v-col class="ma-0 pa-0" md="12">
                    <v-card>
                      <AdvertismentCards></AdvertismentCards>
                    </v-card>
                  </v-col>
                </v-row>
                <!--Phone Article-->
                <v-row class="ma-0 pa-0 pa-2">
                  <v-col class="ma-0 pa-0">
                    <v-hover>
                      <v-card
                        outlined
                        :to="{
                          name: `frontpage`,
                          params: { articleid: article.id },
                        }"
                        replace
                        slot-scope="{ hover }"
                        :class="`expandCard elevation-${hover ? 12 : 0}`"
                        style="border:solid 1px black;"
                        class="pa-2"
                        height="100%"
                      >
                        <!--Image-->
                        <v-row class="ma-0 pa-0 pt-4">
                          <v-col
                            :grow="$vuetify.breakpoint.xs"
                            :shrink="$vuetify.breakpoint.smAndUp"
                            class="ma-0 pa-0"
                          >
                            <v-img
                              v-if="
                                article.MediaData &&
                                  article.MediaData.length > 0
                              "
                              :src="`${article.MediaData[0]['s3url']}-web.jpg`"
                              width="100%"
                              height="120px"
                              :aspect-ratio="1.77"
                              cover
                            />
                            <v-img
                              v-else
                              :src="`/lrVxWoHA.png`"
                              width="100px"
                              height="100px"
                              contain
                            />
                          </v-col>
                        </v-row>
                        <!--Title-->
                        <v-row class="ma-0 pa-0">
                          <v-col class="ma-0 pa-0">
                            <p
                              class="font-weight-bold title pa-0 pt-4 ma-0"
                              style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                            >
                              {{ article.Title }}
                            </p>
                          </v-col>
                        </v-row>
                        <!--Tags-->
                        <!-- <v-row class="ma-0 pa-0">
                        <v-col class="ma-0 pa-0">
                          <div class="text-uppercase subtitle-2">
                            <span class="font-weight-bold">{{ article.GeoTagsLabel ? article.GeoTagsLabel.split(",").join(" - ") : "" }}</span>
                            <span class="px-2">/</span>
                            <span class="font-weight-bold">{{ article.TagsLabel ? article.TagsLabel.split(",").join(" - ") : "" }}</span>
                          </div>
                        </v-col>
                      </v-row> -->
                        <!--Created-->
                        <v-row class="ma-0 pa-0">
                          <v-col class="ma-0 pa-0 subtitle-2">
                            <span class="font-weight-light">{{
                              article.Created | localizeDate | moment("LLL")
                            }}</span>
                          </v-col>
                        </v-row>
                        <!--Text-->
                        <v-row class="ma-0 pa-0">
                          <v-col class="ma-0 pa-0 py-2 pr-2">
                            <div
                              style="display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; overflow: hidden;"
                              v-html="article.Content"
                            />
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-hover>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </template>
        </v-row>
        <!--Displayed when loading next set of articles-->
        <v-row v-if="lazyloading">
          <v-col md="12">
            <v-sheet color="grey" class="px-3 pt-3 pb-3">
              <v-skeleton-loader type="card">
                {{$t('Please wait while we are gathering data')}}
                <v-progress-circular
                  indeterminate
                  color="green"
                  :size="70"
                  :width="7"
                ></v-progress-circular>
              </v-skeleton-loader>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
// General components
import FrontpageCreateArticleButton from "./components/general/button/FrontpageCreateArticleButton";
// Desktop specific components
import RandomFeed from "./components/desktop/randomFeed/randomFeed.vue";
// Phone specific components

// Sort
import AdvertismentCards from "./components/advertismentCards/advertismentCards.vue";
import articleComponentTwo from "./components/article_v2";
import AdvertismentCardTwo from "@/components/dialogs/AdvertismentCardTwo.vue";
import DummyAdvertismentCard from "@/components/dialogs/dummyAdvertismentCard.vue";
import headerModuleDivider from "./components/headermoduledivider";
import headerModuleUserNav from "./components/headermoduleusernav";
import articleComponent from "./components/article";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import { mapGetters, mapActions } from "vuex";
import messages from "./modules/lang/main/export";
export default {
  i18n: { messages },
  components: {
    AdvertismentCards,
    articleComponentTwo,
    AdvertismentCardTwo,
    DummyAdvertismentCard,
    headerModuleDivider,
    headerModuleUserNav,
    articleComponent,
    VueperSlides,
    VueperSlide,
    FrontpageCreateArticleButton,
    RandomFeed,
  },
  data() {
    return {
      sizeRSS: 8,
      fromRSS: 0,

      size: 19,
      from: 0,

      lazyloading: false,
      lazyloadingtimer: 0,

      menu: false,
      viewarticle: false,
      filterDialog: false,
      Article: {
        id: null,
        currentLanguage: "",
        Created: null,
        Updated: null,
        Category: "",
        ArticleType: "",
        Comments: false,
        OrgLanguage: "",
        Pages_id: "",
        Subscription_id: null,
        Users_id: null,
        Content: [],
        Media: [],
        Tags: [],
        GeoTags: [],
      },
      SERVERADRESS: process.env.VUE_APP_BASEAPI,
      waitForServerResponse: false,
      waitForServerResponseMsg: this.$t("Please wait..."),
      activeProfile: localStorage.getItem("activeProfile") || 0,
      articleTimeout: null,
      articlenaTimeout: null,
      currentGeo: [],
      currentTag: [],
      Articles: [],
      ArticlesFeed: [],
      SearchArticles: "",
      newGeoTags: localStorage.getItem("geotags")
        ? JSON.parse(localStorage.getItem("geotags"))
        : [],
      Geo: {
        SearchTags: localStorage.getItem("geotags_searchitems")
          ? JSON.parse(localStorage.getItem("geotags_searchitems"))
          : [],
        SearchTimeout: null,
        IsLoading: false,
        Search: "",
      },
      newTags: localStorage.getItem("tags")
        ? JSON.parse(localStorage.getItem("tags"))
        : [],
      Tag: {
        SearchTags: [],
        SearchTimeout: null,
        IsLoading: false,
        Search: "",
      },
    };
  },
  // beforeMount(){
  //   this.pickRandomAdvertisment()
  // },
  watch: {
    getLang(newLocale) {
      this.getArticles();
      // ???
      this.getArticlesFromFeed();
    },
    $route(newVal) {
      if (newVal.params.articleid) {
        this.setArticle(newVal.params.articleid);
      } else if (this.viewarticle) {
        this.viewarticle = false;
      }
    },
    viewarticle(visible) {
      if (visible === false) {
        // remove front/XX
        this.$router.replace({ name: "frontpage", params: {} });
      }
    },
    currentTag() {
      this.getArticles();
      // ???
      this.getArticlesFromFeed();
    },
    currentGeo() {
      this.getArticles();
      // ???
      this.getArticlesFromFeed();
    },
    TagProfiles() {
      this.updateTagList();
    },
    activeProfile(newVal, oldVal) {
      console.log(
        `activeProfile changed from ${oldVal} to ${newVal}, ${this.TagProfiles.length} is search index`
      );
      if (newVal !== this.TagProfiles.length) {
        this.newTags = [];
        this.newGeoTags = [];
        this.SearchArticles = "";
        localStorage.setItem("activeProfile", newVal);
        this.updateTagList();
      }
    },
    "Geo.Search"(newVal) {
      // if (this.Geo.IsLoading) return;
      this.Geo.IsLoading = true;
      clearTimeout(this.Geo.SearchTimeout);
      this.Geo.SearchTimeout = setTimeout(() => {
        this.SEARCH_GEO_SUGGESTION(newVal)
          .then((resp) => {
            this.Geo.SearchTags = resp.data.concat(this.newGeoTags);
          })
          .catch((ex) => console.log(ex))
          .finally(() => {
            this.Geo.IsLoading = false;
          });
      }, 200);
    },
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "authStatus",
      "TagProfiles",
      "getTags",
      "userId",
      "getLang",
    ]),
    firstTagProfile() {
      if (this.TagProfiles && this.TagProfiles.length > 0) {
        return this.TagProfiles[0];
      } else {
        return null;
      }
    },
    otherTagProfiles() {
      if (this.TagProfiles && this.TagProfiles.length > 1) {
        return this.TagProfiles.slice(1);
      } else {
        return null;
      }
    },
    TagsOrdered() {
      let _Tags = this.getTags;
      if (_Tags && _Tags.length > 0) {
        return _Tags.map((tag) => {
          return {
            ...tag,
            Label: tag.TranslatedLabel ? tag.TranslatedLabel : tag.Label,
          };
        });
      } else {
        return [];
      }
    },
    LatestArticles() {
      return this.Articles;
      // .filter(res => res.ArticleType == "article");
    },
    Latest_nav_opprettelse_foretak() {
      return this.Articles.filter(
        (res) => res.ArticleType == "nav_opprettelse_foretak"
      );
    },
    Latest_nav_ledige_stillinger() {
      return this.Articles.filter(
        (res) => res.ArticleType == "nav_ledige_stillinger"
      );
    },
  },

  // Calls from vuex
  methods: {
    ...mapActions([
      "GET_FRONTPAGE",
      "SEARCH_GEO_SUGGESTION",
      "GET_PUBLIC_ARTICLE",
      "GET_FRONTPAGENA",
    ]),

    // Scroll feature
    scroll() {
      window.onscroll = () => {
        if (this.lazyloading) return;
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight >
          document.documentElement.offsetHeight - 100;
        // console.log({bottomOfWindow, scrolltop: document.documentElement.scrollTop, windowinnerheight: window.innerHeight, docheight: document.documentElement.offsetHeight })
        // console.log( document.documentElement.offsetHeight - window.innerHeight - document.documentElement.scrollTop, bottomOfWindow  )
        if (bottomOfWindow) {
          this.lazyloading = true;
          clearTimeout(this.lazyloadingtimer);
          this.lazyloadingtimer = setTimeout(() => {
            this.getNextSet().then(() => {
              this.lazyloading = false;
            });
            this.getNextSetRSS().then(() => {
              this.lazyloading = false;
            });
          }, 300);
        }
      };
    },

    /*
      In the HTML we run a slice through the index, to define which articles we wanna display.
      This will go by the start index up to (not included) the last index.    
        0,4 (articles from index 0 to 4 =  0, 1, 2, 3),  
        4,8 (articles from index 4 to 8  = 4, 5, 6, 7)     

      It looks like this.   
        <template v-for="(articlefeed) in ArticlesFeed.slice(getArrayFeedIndex(index), getArrayFeedIndex(index + 8) )">

      (getArrayFeedIndex(index))   = Start of the index
      , getArrayFeedIndex(index + 8) = Up to this index



      ArticleIndex = Current index of the articles. (8, 16, 24, 32, 40 ...)
      CurrentIndex = ArticleIndex / 8  = (1, 2, 3, 4, 5 ....)
      
      Lastly we take the currentIndex and multiply it with 4.
      
      (currentIndex * 4)     = 1*4, 2*4, 3*4, 4*4, 5*4    (4, 8. 12. 16. 20)

      Then to finish it up, we subsrtact 4
      4-4, 8-4, 12-4, 16-4, 20-4  (0, 4, 8, 12, 16)

      This we use to decide the starting point of the articles within the array. 
      
    */
    getArrayFeedIndex(ArticleIndex) {
      let currentIndex = Math.floor(ArticleIndex / 8);
      return currentIndex * 4 - 4;
    },

    // Get all the articles
    getArticles() {
      return new Promise((resolve, reject) => {
        if (this.Articles.length > 0) this.waitForServerResponse = true;
        this.waitForServerResponseMsg = this.$t(
          "Sorting articles, please wait.."
        );
        clearTimeout(this.articleTimeout);
        this.articleTimeout = setTimeout(() => {
          this.GET_FRONTPAGE({
            size: this.size,
            from: this.from,
            test: "hello",
            GeoTags: this.currentGeo,
            Tags: this.currentTag,
            Lang:
              localStorage.getItem("setlanguage") ||
              localStorage.getItem("detectedlanguage") ||
              "en",
            Search:
              this.activeProfile === this.TagProfiles.length
                ? this.SearchArticles
                : "",
          })
            .then((resp) => {
              this.Articles = resp.data;
              if (this.from === 0) {
                this.scroll(this.articl);
              }
            })
            .catch((ex) => {
              console.error(ex);
            })
            .finally(() => {
              this.waitForServerResponse = false;
              resolve(true);
            });
        }, 200);
      });
    },

    // Getting next set of articles, when scrolling
    getNextSet() {
      return new Promise((resolve, reject) => {
        this.GET_FRONTPAGE({
          size: this.size,
          from: this.from + this.size,
          GeoTags: this.currentGeo,
          Tags: this.currentTag,
          Lang:
            localStorage.getItem("setlanguage") ||
            localStorage.getItem("detectedlanguage") ||
            "en",
          Search:
            this.activeProfile === this.TagProfiles.length
              ? this.SearchArticles
              : "",
        })
          .then((response) => {
            this.from = this.from + this.size;
            this.Articles = [...this.Articles, ...response.data];
            resolve();
            // this.Articles=[]
          })
          .catch((ex) => {
            console.error(ex);
            reject();
          });
      });
    },

    // For now - on button press, get more rss
    getNextSetRSS() {
      return new Promise((resolve, reject) => {
        this.GET_FRONTPAGENA({
          // Size is from sizeRSS in data() above.   It define how many RSS articles to load each iteration
          size: this.sizeRSS,
          /* 
            From are the index. As we display index start -> up to.  (0 -> 4,   4 -> 8)
            Takes the current index + new size
          */
          from: this.fromRSS + this.size,
          GeoTags: this.currentGeo,
          Tags: this.currentTag,
          Lang:
            localStorage.getItem("setlanguage") ||
            localStorage.getItem("detectedlanguage") ||
            "en",
          Search:
            this.activeProfile === this.TagProfiles.length
              ? this.SearchArticles
              : "",
        })
          .then((response) => {
            // Update the new fromRSS index with + size
            this.fromRSS = this.fromRSS + this.size;
            this.ArticlesFeed = [...this.ArticlesFeed, ...response.data];
            resolve();
            // this.Articles=[]
          })
          .catch((ex) => {
            console.error(ex);
            reject();
          });
      });
    },

    // Get articles from other sources - NRK, NAV, Brønnøysund or Twitter
    getArticlesFromFeed() {
      // Run a Promise
      return new Promise((resolve, reject) => {
        // If the lenght of the Articles isnt bigger than 0, then wait for an response is true
        if (this.ArticlesFeed.length > 0) this.waitForServerResponse = true;
        // If we are waiting, then this is the message that will be displayed
        this.waitForServerResponseMsg = this.$t(
          "Sorting articles, please wait.."
        );
        // ???
        clearTimeout(this.articlenaTimeout);
        // ???
        this.articlenaTimeout = setTimeout(() => {
          // Run the get call from store.js - getting all the feed articles
          this.GET_FRONTPAGENA({
            size: this.sizeRSS,
            from: this.fromRSS,

            // ???
            GeoTags: this.currentGeo,
            // ???
            Tags: this.currentTag,
            // ???
            Lang:
              localStorage.getItem("setlanguage") ||
              localStorage.getItem("detectedlanguage") ||
              "en",
            // ???
            Search:
              this.activeProfile === this.TagProfiles.length
                ? this.searchArticles
                : "",
            // The response of the function above
          })
            .then((response) => {
              // Article feed array are filled with the response data
              this.ArticlesFeed = response.data;
              // ex? ??
            })
            .catch((ex) => {
              // check the result of ex?? in the console.log
              console.error(ex);
              // ??
            })
            .finally(() => {
              // ??
              this.waitForServerResponse = false;
              // ??
              resolve(true);
            });
          // Timeout?
        });
      });
    },

    updateTagList() {
      console.log(this.isLoggedIn);
      console.log(this.activeProfile);
      if (this.activeProfile === this.TagProfiles.length) {
        console.log("custom profile");
        this.currentGeo = this.newGeoTags.map((res) => res.id) || [];
        this.currentTag = this.newTags.map((res) => res.id) || [];
      } else {
        if (this.TagProfiles && this.TagProfiles.length > 0) {
          let _index = 0;
          if (this.TagProfiles.hasOwnProperty(this.activeProfile)) {
            _index = this.activeProfile;
          } else {
            this.activeProfile = _index;
          }
          this.currentGeo =
            (
              this.TagProfiles[_index] && this.TagProfiles[_index]["GeoTags"]
            ).map((res) => res.id) || [];
          this.currentTag =
            (this.TagProfiles[_index] && this.TagProfiles[_index]["Tags"]).map(
              (res) => res.id
            ) || [];
        } else {
          console.log("delaying updatetaglist");
          setTimeout(this.updateTagList, 200);
        }
      }
    },
    removeGeoTag(item) {
      this.newGeoTags = this.newGeoTags.filter((geo) => geo.id != item.id);
    },
    removeTag(item) {
      this.newTags = this.newTags.filter((geo) => geo.id != item.id);
    },
    selectedGeoEvent(evt) {
      this.Geo.Search = "";
    },
    selectedTagEvent(evt) {
      this.Tag.Search = "";
    },
    createTempProfile(evt) {
      this.menu = false;
      if (
        this.newGeoTags.length == 0 &&
        this.newTags.length == 0 &&
        this.SearchArticles == ""
      ) {
        return false;
      }
      localStorage.setItem("geotags", JSON.stringify(this.newGeoTags));
      localStorage.setItem(
        "geotags_searchitems",
        JSON.stringify(this.Geo.SearchTags)
      );
      localStorage.setItem("tags", JSON.stringify(this.newTags));
      this.activeProfile = this.TagProfiles.length;
      this.Articles = [];
      localStorage.setItem("activeProfile", this.activeProfile);

      this.updateTagList();
      // Delete the one not in use, del if nr 2
      this.filterDialog = false;
    },
    resetArticle() {
      this.Article.id = null;
      this.Article.currentLanguage = "";
      this.Article.Created = null;
      this.Article.Updated = null;
      this.Article.Category = "";
      this.Article.ArticleType = "";
      this.Article.Comments = false;
      this.Article.OrgLanguage = "";
      this.Article.Pages_id = "";
      this.Article.Subscription_id = null;
      this.Article.Users_id = null;
      this.Article.Content = [];
      this.Article.Media = [];
      this.Article.Tags = [];
      this.Article.GeoTags = [];
    },
    setArticle(id) {
      console.log("set article triggered");
      if (!id && this.Article.id) id = this.Article.id;
      this.viewarticle = true;
      this.resetArticle();
      this.GET_PUBLIC_ARTICLE(id).then((resp) => {
        const regex = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;

        resp.data.Content.forEach((content) => {
          if (resp.data.ArticleType == "article") {
            content.Content = content.Content.replace(regex, (match) => {
              return `<a href="${match}" target="_blank">${match}</a>`;
            });
            content.Content = content.Content.replace(
              /(?:\r\n|\r|\n)/g,
              "<br>"
            );
          }
        });
        this.Article = resp.data;
      });
    },
    // ????
    setArticleFeed(id) {
      // To see that it is running
      console.log("set Article Feeds are triggered");
      // ???
      if (!id && this.Article.id) id = this.Article.id;
      // ???? - Look up
      this.viewarticle = true;
      // ???
      this.resetArticle();
      // ???
      this.GET_PUBLIC_ARTICLE(id).then((response) => {
        // ???
        const regex = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
        // ???
        response.data.Content.forEach((content) => {
          // ???
          content.Content = content.Content.replace(regex, (match) => {
            // ???
            return `<a href="${match}" target="_blank">${match}</a>`;
          });
          // ???
          content.Content = content.Content.replace(/(?:\r\n|\r|\n)/g, "<br>");
        });
        // ????
        this.Article = response.data;
      });
    },
  },

  mounted() {
    Promise.all([this.getArticles(), this.getArticlesFromFeed()]).then(() => {
      if (this.$route.params && this.$route.params.articleid) {
        this.setArticle(this.$route.params.articleid);
      }
    });
  },
};

function compareCreatedFunction(a, b) {
  let Property = "Created";
  if (a[Property] < b[Property]) return -1;
  if (a[Property] > b[Property]) return 1;
  return 0;
}
</script>

<style scoped>
.expandCard {
  transition: all 1s;
  /* transition-timing: ease-in-out; */
}
.expandCard:hover {
  transition: 0.5s;
  transform: scale(1.03);
}

.moduleheader {
  font-size: 2em;
  font-weight: 400;
  position: relative;
}
/* .moduleheader:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -24px;
  border-bottom: 2px solid #cc0000;
  width: 50px;
} */
.redborderbottom {
  border-bottom: 2px solid #cc0000 !important;
}
.greenborderbottom {
  border-bottom: 2px solid #065313 !important;
}
.topbar-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: flex-start;
}
.topbar-container > * {
  width: 100%;
  margin-bottom: 20px;
}

.topbar-container .left {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  text-align: left;
}

.topbar-container .center {
  order: 0;
  flex: 0 2 auto;
  align-self: auto;
}
.topbar-container .center img {
  width: 150px;
}

.topbar-container .right {
  margin: 15px;
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  text-align: right;
}
.topbar-container .right a,
a.articlelinks {
  text-decoration: none;
  color: black;
}
.topbar-container .right a:hover,
a.articlelinks:hover {
  text-decoration: underline;
}
.topbar-menu-container {
  border-bottom: 4px solid black;
  padding-bottom: 20px;
}
.topbar-menu-container .flex {
  text-align: center;
  font-size: 1.2em;
}

.topbar-breakingnews {
  margin-top: 20px;
  border: 4px solid #000000;
  background-color: #000000;
}
.breakingnews.label {
  background-color: #000000;
  color: #ffffff;
  padding: 0 10px;
  position: relative;
}
.breakingnews.flashcolorred {
  animation: labelFlash linear 2s infinite;
}
@keyframes labelFlash {
  0% {
    color: #ffffff;
  }
  20% {
    color: #cc0000;
  }
  60% {
    color: #ffffff;
  }
  100% {
    color: #ffffff;
  }
}
/* .breakingnews.label:before {
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;

  color: #cc0000;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\f111";
  position: absolute;
  left: 4px;
  border-radius: 50%;
  border: 2px solid red;
  width: 23px;
} */

.breakingnews.redcircle {
  display: inline-block;
  /* background-color: #cc0000; */
  border: 1px solid black;
  border-color: #000000;
  border-style: solid;

  box-shadow: 0 0 0 2px #dd0000;
  height: 10px;
  width: 10px;

  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  margin-right: 5px;
  position: relative;
  /* top:2px; */
  left: 5px;
  animation: circularshadowrotate linear 1s infinite;
}

@keyframes circularshadowrotate {
  0% {
    box-shadow: 0 0 0 2px #dd0000;
  }
  25% {
    box-shadow: 2px 0 0 2px #dd0000;
  }
  50% {
    box-shadow: 2px 2px 0 2px #dd0000;
  }
  75% {
    box-shadow: 0 2px 0 2px #dd0000;
  }
  100% {
    box-shadow: 0 0 0 2px #dd0000;
  }
}
.breakingnews.blackarrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3.5px 0 3.5px 7px;
  border-color: transparent transparent transparent #000000;
}
.breakingnews.content {
  padding-left: 20px;
  width: 100%;
}
.breakingnews.whitearrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3.5px 0 3.5px 7px;
  border-color: transparent transparent transparent #ffffff;
}
.breakingnews.readmore {
  background-color: #000000;
  color: #ffffff;
  padding: 1px 20px;
}

.greybottomborder {
  border-bottom: 2px solid #aeaeae !important;
}
</style>

<style>
.frontpageslideshow1 .vueperslides__bullets {
  left: auto;
  width: 30px;
  /* height: 50%; */
  bottom: 30px;
  right: 30px;
  flex-direction: column;
  justify-content: center;
  /* align-content: flex-end; */
  align-items: center;
  /* background-color: rgba(0,0,0,0.1); */
  z-index: 10;
}
.frontpageslideshow1 a {
  text-decoration: none;
  color: inherit;
}
.frontpageslideshow1 {
  color: white;
  text-shadow: -2px 0 black, 0 2px black, 2px 0 black, 0 -2px black;
}
.frontpageslideshow1 .vueperslides__bullet {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: none;
  transition: 0.3s;
  width: 10px;
  height: 10px;
  margin: 4px 0;
}

/* .frontpageslideshow1 .vueperslides__bullet--active {
  background-color: #cc0000;
  border: 1px solid #cc0000;
} */

.frontpageslideshow1 .vueperslides__bullet span {
  display: none;
}
.profile_0 {
  background: white !important;
  color: black !important;
}
</style>
